import { useContext } from 'react';
import { MsMapContext } from '../providers/MsMapProvider';

export default function useMsMap() {
  return useContext(MsMapContext);
}
